// extracted by mini-css-extract-plugin
export default {"verticalFeaturesSkeleton":"fI_QdWlY9_2Gk8yUc4mk","featureItem":"AzDk2IYv3AI6X4tQv6QN"};